import React, { useState } from 'react';
import PropTypes from 'prop-types'

const ImageDropdownInput = (props) => {

    const [selected, setSelected] = useState(props.selected);

    const handleClick = (event) => {
        const val = event.target.getAttribute("data-value")
        setSelected(val)
        props.onChange(val)
    }



    const renderOptions = () => {
        return props.options.map(e => {
            return (
                <li key={e.value}><img className={`${selected===e.value ? "selected" : ""}`} data-value={e.value} src={e.imgSrc} alt={e.imgAlt} /></li>
            );
        });
    }

    return (
        <div className="dropdown">
            <button className={`btn ${selected}`}>{props.text}</button>
            <ul className="dropdown-content" onClick={handleClick}>
                {renderOptions()}
            </ul>
        </div>
    );

}

ImageDropdownInput.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}


export default ImageDropdownInput;